import React, { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { TileListComponent } from '@/components';
import Modal from './Modal';
import AccordionModal from "../AccordionModal";

const Refinement = ({
                 parentId,
                 headline,
                 onItemClick,
                 loadingIndex,
                 isFetching,
                 values,
                 tooltip,
                 linkText = Drupal.t('More Information'),
                 tileClassName = 'w-1/2 h-6xl',
               }) => {
  const hasValueTooltips = values.length > 0 && values.every(value => value.tooltip && value.tooltip.trim() !== '');
  const hasTooltip = hasValueTooltips || !!tooltip;

  const [componentState, updateComponentState] = useImmer({
    isModalOpen: false,
    activeAccordionIndex: values.findIndex((value) => value.is_selected),
  });

  const openModal = () => {
    updateComponentState((draft) => {
      draft.isModalOpen = true;
    });
  };

  const closeModal = () => {
    updateComponentState((draft) => {
      draft.isModalOpen = false;
    });
  };

  const selectTooltip = (i) => {
    updateComponentState((draft) => {
      draft.activeAccordionIndex = i;
    });
  };

  useEffect(() => {
    document.body.style.overflow = componentState.isModalOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [componentState.isModalOpen]);

  useEffect(() => {
    if (!loadingIndex && componentState.isModalOpen) {
      closeModal();
    }
  }, [loadingIndex]);

  useEffect(() => {
    updateComponentState((draft) => {
      draft.activeAccordionIndex = values.findIndex(value => value.is_selected);
    });
  }, [values]);

  return (
    <>
      <TileListComponent
        id='refinement'
        parentId={parentId}
        getItemDataAttributes={(item) => ({'refinement': item.id})}
        tileClassName={tileClassName}
        isDisabled={isFetching}
        items={values}
        LoadingIcon={() => (
          <ft-spinner size="small"></ft-spinner>
        )}
        linkText={hasTooltip ? linkText : ''}
        onLinkClick={() => openModal()}
        {...{
          headline,
          onItemClick,
          loadingIndex
        }}
      />
      <If condition={componentState.isModalOpen && hasValueTooltips}>
        <AccordionModal
          headline={linkText}
          ctaLabel={Drupal.t('Select')}
          closeModal={() => closeModal()}
          activeAccordionIndex={componentState.activeAccordionIndex}
          selectTooltip={selectTooltip}
          {...{
            values,
            parentId,
            onItemClick,
            loadingIndex
          }}
        />
      </If>
      <If condition={componentState.isModalOpen && !hasValueTooltips}>
        <Modal
          closeModal={() => closeModal()}
          title={linkText}
          {...{
            tooltip
          }}
        />
      </If>
    </>
  );
};

export default Refinement;
